<template>
  <div class="position-switcher" v-if="positions.length">
    <span class="position-label">岗位：</span>
    <el-select
      class="position-select"
      :value="selectedKey"
      :disabled="switching"
      :loading="switching"
      size="mini"
      @change="handleChange"
    >
      <el-option v-for="item in positions" :key="item.optionKey" :label="positionLabel(item)" :value="item.optionKey" />
    </el-select>
  </div>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { postAction } from '@/api/manage'

export default {
  name: 'PositionSwitcher',
  data() {
    return {
      positions: [],
      selectedKey: '',
      switching: false
    }
  },
  mounted() {
    this.loadPositions()
  },
  methods: {
    loadPositions() {
      postAction('/sys/historicalPosition', null).then(res => {
        const result = res.result || {}
        this.positions = (result.allTerritory || []).map(item => ({
          ...item,
          optionKey: `${item.id}_${item.ym}`
        }))
        const currentYm = `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`
        let selected = this.positions.find(
          item =>
            result.currentTerritoryId != null &&
            result.currentYm != null &&
            String(item.id) === String(result.currentTerritoryId) &&
            String(item.ym) === String(result.currentYm)
        )
        if (!selected) {
          selected = this.positions.find(
            item => String(item.id) === String(result.currentTerritoryId) && String(item.ym) === currentYm
          )
        }
        if (!selected) {
          selected = this.positions.find(item => String(item.id) === String(result.currentTerritoryId))
        }
        this.selectedKey = selected ? selected.optionKey : ''
      })
    },
    positionLabel(position) {
      return `${position.post || '--'} | ${position.code || '--'} | ${position.ym || '--'}`
    },
    handleChange(optionKey) {
      if (!optionKey || optionKey === this.selectedKey) return
      const selected = this.positions.find(item => item.optionKey === optionKey)
      if (!selected) return
      this.$dialog.confirm({
        title: '切换岗位',
        message: `确定切换到 ${this.positionLabel(selected)} 吗？`,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickOverlay: false
      })
        .then(() => {
          this.switching = true
          return postAction('/sys/switchLogin', {
            switchTerritoryId: selected.id,
            switchYm: selected.ym
          })
        })
        .then(res => {
          if (!res || !res.success) {
            this.$toast((res && res.message) || '岗位切换失败')
            return
          }
          if (res.result && res.result.token) {
            Vue.ls.set(ACCESS_TOKEN, res.result.token)
          }
          this.selectedKey = optionKey
          Vue.ls.set('postKey', [selected.id])
          Vue.ls.set('currentPositionLabel', this.positionLabel(selected))
          this.$toast.success('岗位切换成功')
          this.$emit('switched', selected)
        })
        .catch(() => {})
        .finally(() => {
          this.switching = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.position-switcher {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  border-bottom: 1px solid #eef1f5;
  font-size: 12px;
}

.position-label {
  flex-shrink: 0;
  color: #606266;
}

.position-select {
  flex: 1;
  min-width: 0;
}

/deep/ .el-input__inner {
  padding-left: 8px;
  padding-right: 26px;
  border-color: #dcdfe6;
  font-size: 12px;
}
</style>
